<template>
	<div>
		<iframe
			v-bind:id="'thumbnail'+dir"
			class="thumbnail"
			:alt="dir"
		></iframe>
		<p v-if="techdoc_id!=undefined" class="subtext">{{techdoc_id}}</p>
	</div>
</template>

<script>
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		dir: String,
		id: {
			type: Number,
			required: false,
			default: -1
		},
		techdoc_id: String,
		pageid:Number,
    },
	data() {
		return {

		}
	},
	mounted () {
		this.setTechdoc();
	},
	methods:{
		async setTechdoc(){
			document.getElementById("thumbnail"+this.dir).src = api.getTechdocUrl(this.id);

			api.getTechdoc(
                {
					data:{
						pageid:this.pageid,
						techdocsid:this.id
					}
                }
            ).then((res) => {
				if (res.data) {
					this.$emit('load', res.data.filename, res.data.notes);
				}
	        });
		},
	},
	watch:{
		dir(){
			this.setTechdoc();
		},
		id(){
			this.setTechdoc();
		},
		techdoc_id(){
			this.setTechdoc();
		},
	},
}
</script>

<style scoped>
.subtext{
	font-size: 12px;
	font-weight: normal;
	display:flex;
	flex-wrap: wrap;
	justify-content:left;
}

.thumbnail{
	width:100%;
	height:100%;
	border: 1px solid #ddd;
	border-radius: 4px;
	padding: 5px;
}

</style>



// WEBPACK FOOTER //
// src/layouts/techdoc.vue